module.exports = __webpack_public_path__ + "static/img/preview-01.2a115153.webp";